export default __webpack_public_path__ + "static/media/refreshing-clementine.dfdb236f.png";